import { Stack } from "@mui/material";
import { useAtom } from "jotai";
import type { FC } from "react";
import { RecentTimelineItemTypeFilterEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { timelineFilterAtom } from "web_myplann/NotificationCenter/Atoms/timelineFilterAtom";
import { FilterRow } from "web_myplann/NotificationCenter/FilterScreen/FilterRow";
import { FilterSection } from "web_myplann/NotificationCenter/FilterScreen/FilterSection";
import { typeResource } from "web_myplann/NotificationCenter/Utils/filterLabels";

const TYPE_OPTIONS: RecentTimelineItemTypeFilterEnum[] = [
	RecentTimelineItemTypeFilterEnum.All,
	RecentTimelineItemTypeFilterEnum.Activities,
	RecentTimelineItemTypeFilterEnum.Events,
	RecentTimelineItemTypeFilterEnum.Notifications,
];

export const RecentFilters: FC = () => {
	const { t } = useResource();
	const [filter, setFilter] = useAtom(timelineFilterAtom);

	return (
		<Stack data-testid="notification-center-filter-recent">
			<FilterSection
				title={t(Resources.NotificationCenter.FilterScreen.TypeSectionTitle)}
				testIdPrefix="type"
			>
				{TYPE_OPTIONS.map((option, i) => (
					<FilterRow
						key={option}
						label={t(typeResource(option))}
						selected={filter.recentType === option}
						onClick={() =>
							setFilter((prev) => ({ ...prev, recentType: option }))
						}
						isLast={i === TYPE_OPTIONS.length - 1}
						testId={`notification-center-filter-type-${option}`}
					/>
				))}
			</FilterSection>
		</Stack>
	);
};
